// extracted by mini-css-extract-plugin
export default {"Header__Section":"Protection_Header__Section__nhXSM","Protection__Page__Wrapper":"Protection_Protection__Page__Wrapper__14NwE","Page__Title":"Protection_Page__Title__VKc64"};